exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".input-map-container {\n  display: flex;\n  flex-direction: column;\n}", "",{"version":3,"sources":["CustomMap.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF","file":"CustomMap.scss","sourcesContent":[".input-map-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n}"]}]);

